import React, { Component } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { Row, Col, Breadcrumb, BreadcrumbItem } from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";
import { Grid, Stack } from '@mui/material';
import Label from './Label';
import CustomButton from '../Form/CustomButton';

class Breadcrumbs extends Component {
    render() {
        const itemsLength = this.props.breadcrumbItems.length;
        return (
            <React.Fragment>
                <Grid container className='page-title-box ' spacing={2} mb={2}>
                    <Grid item xs={12} sm={8} display={'flex'} alignItems={'center'}>
                        <Link to={this.props.backRoute}>
                            <CustomButton
                                title={<Stack sx={{ fontSize: { xs: "16px", sm: "20px" } }}><i className="ri-arrow-left-line" /></Stack>}
                                press={() => ""}
                                backgroundColor={'transparent'}
                                textColor={'#999999'}
                                borderStyle={"1px solid #D0D0D0"}
                                paddingInline={12}
                                padding={5}
                            />
                        </Link>
                        <Breadcrumb listClassName="mx-2 m-0" className='header'>
                            {
                                this.props.breadcrumbItems.map((item, key) =>
                                    key + 1 === itemsLength ?
                                        <BreadcrumbItem key={key} active style={{ fontFamily: 'Manrope-Bold', color: '#101010', marginLeft: (key + 1 > 2) ? 10 : 0 }}><Stack sx={{ fontSize: { xs: "20px", sm: "24px" } }}>{this.props.t(item.title)}</Stack></BreadcrumbItem>
                                        : <BreadcrumbItem key={key} ><Link to={item.link} style={{ fontFamily: 'Manrope' }}><Stack sx={{ fontSize: { xs: "20px", sm: "24px" } }}>{this.props.t(item.title)}</Stack></Link></BreadcrumbItem>
                                )
                            }
                        </Breadcrumb>
                    </Grid>
                    {
                        this.props?.children &&
                        <Grid item xs={12} sm={4} sx={{ display: 'flex', justifyContent: { lg: 'end', sm: 'end', xs: 'start' } }}>
                            {this.props.children}
                        </Grid>
                    }

                    {/* <div className="page-title-box d-flex align-items-center justify-content-between">
                        <h4 className="mb-0">{this.props.t(this.props.title)}</h4>

                        <div className="">
                            <Breadcrumb listClassName="m-0">
                                {
                                    this.props.breadcrumbItems.map((item, key) =>
                                        key + 1 === itemsLength ?
                                            <BreadcrumbItem key={key} active>{this.props.t(item.title)}</BreadcrumbItem>
                                            : <BreadcrumbItem key={key} ><Link to={item.link}>{this.props.t(item.title)}</Link></BreadcrumbItem>
                                    )
                                }
                            </Breadcrumb>
                        </div>

                    </div> */}
                </Grid>
            </React.Fragment>
        );
    }
}

export default withTranslation()(Breadcrumbs);